module.exports = __webpack_public_path__ + "static/media/amsterdam.731a7e6f.jpg";